import ReportSelect from "./ReportSelect";

function ZoneRatioSwitchReport(props) {
  return <ReportSelect type={"zone-ratio-switch-report"} />;
}

export default ZoneRatioSwitchReport;
